const isProduction = () => window.location.hostname === 'platform.mikmak.tv';

export default { isProduction };
